import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { SamphireLogo } from "../assets/logos/samphireLogo";
import { AuthForm } from "../components/auth/AuthForm";
import { Button } from "../components/coreUI/button";

export default function Auth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialMode = searchParams.get("mode") === "login" ? "login" : "signup";

  const handleAuthSuccess = () => {
    // Check for redirect URL in search params
    const redirectParam = searchParams.get("redirect");
    const decodedRedirect = redirectParam
      ? decodeURIComponent(redirectParam)
      : undefined;
    // Security: Allow only same-origin internal paths to prevent open redirect
    const isSafeInternalPath =
      typeof decodedRedirect === "string" &&
      decodedRedirect.startsWith("/") &&
      !decodedRedirect.startsWith("//");

    navigate(isSafeInternalPath ? decodedRedirect : "/");
  };

  return (
    <div className="w-screen h-screen pt-[1vh]  items-center justify-center ">
      <div className="max-w-[350px] mx-auto flex flex-col items-center justify-center my-auto ">
        <div className="w-full h-full flex flex-col items-center justify-center mt-8 mb-8 px-8">
          <Link to="/" className="cursor-pointer">
            <SamphireLogo width={200} className="text-foreground-primary" />
          </Link>
          <p className="text-xl font-semibold text-foreground-secondary">
            Member Portal
          </p>
        </div>

        <AuthForm
          initialMode={initialMode}
          onAuthSuccess={handleAuthSuccess}
          signupCallbackURL={`${window.location.origin}/v2/static/email-verified?authMode=login`}
          skipNavigationOnSignup={false}
        />

        <Button
          as="link"
          to="/forgot-password"
          variant="tertiary"
          size="default"
          type="button"
          className="mt-4"
        >
          Forgot your password?
        </Button>
      </div>
    </div>
  );
}
